import { ReactNode, useEffect, useRef, useState } from "react";

interface IProps {
    dataLength: number;
    firstWidth?: number;
    children?: ReactNode;
    isPagination?: boolean
    initialIndex?: number;
}

const CunstomAbleCarousel = ({ dataLength, firstWidth, children, isPagination = true, initialIndex }: IProps) => {
    const [current, setCurrent] = useState<number>(initialIndex ?? 0);
    const [isDragging, setIsDragging] = useState<boolean>(false);
    const [startX, setStartX] = useState<number>(0);
    const [dragOffset, setDragOffset] = useState<number>(0);
    const [autoSlide, setAutoSlide] = useState<boolean>(true);
    const ref = useRef<HTMLDivElement>(null);

    const startAutoSlide = () => {
        return setInterval(() => {
            if (autoSlide) {
                setCurrent((curr) => (curr === dataLength - 1 ? 0 : curr + 1));
            }
        }, 3000);
    };

    const onDragStart = (e: React.MouseEvent | React.TouchEvent) => {
        const clientX = e.nativeEvent instanceof MouseEvent ? e.nativeEvent.clientX : (e as React.TouchEvent).touches?.[0].clientX;
        setIsDragging(true);
        setStartX(clientX);
        setAutoSlide(false);
    };

    const onDragMove = (e: React.MouseEvent | React.TouchEvent) => {
        if (!isDragging) return;
        const clientX = e.nativeEvent instanceof MouseEvent ? e.nativeEvent.clientX : (e as React.TouchEvent).touches?.[0].clientX;
        setDragOffset(clientX - startX);
    };

    const onDragEnd = (e: React.MouseEvent | React.TouchEvent) => {
        if (!isDragging) return;
        setIsDragging(false);
        const threshold = 100;
        if (dragOffset > threshold) {
            setCurrent((prev) => (prev === 0 ? dataLength - 1 : prev - 1));
        } else if (dragOffset < -threshold) {
            setCurrent((prev) => (prev === dataLength - 1 ? 0 : prev + 1));
        }
        setDragOffset(0);
        setAutoSlide(true);
    };

    const calcTranslateX = () => {
        const targetOffsetWidth = firstWidth ?? 320;
        const returnValue = current * targetOffsetWidth;
        return `calc(-${returnValue - dragOffset}px + ${current === 0 ? 2.134 : 2.134}vw)`
    }
    useEffect(() => {
        const interval = startAutoSlide();
        return () => clearInterval(interval);
    }, [dataLength, autoSlide]);

    return <>
        <div style={{ display: "flex", overflowX: 'hidden' }} ref={ref}
            onMouseDown={onDragStart}
            onTouchStart={onDragStart}
            onMouseMove={onDragMove}
            onTouchMove={onDragMove}
            onMouseUp={onDragEnd}
            onTouchEnd={onDragEnd}
            onMouseLeave={onDragEnd}
        >
            <div style={{
                display: "flex", transform: `translateX(${calcTranslateX()})`,
                transition: isDragging ? "none" : "transform 0.5s ease",
                marginLeft: 0,
                maxWidth: `calc(100% * ${dataLength})`
            }}>
                {children}
            </div>
        </div>
        {isPagination && dataLength > 1 &&
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
                {Array.from({ length: dataLength }, (_, index) => (
                    <div
                        key={index}
                        style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            backgroundColor: index === current ? 'var(--secondarys500)' : 'var(--secondarys200)',
                            marginRight: '4px',
                            cursor: 'pointer',
                        }}
                        onClick={() => setCurrent(index)}
                    />
                ))}
            </div>}
    </>
}

export default CunstomAbleCarousel;